module.exports = __webpack_public_path__ + "img/emitLipscolorchanger05.f8aae6c4.png";